import React from 'react'

import { useQuery } from '../hooks/useQuery'

const withOutcomes = BaseComponent => props => {
  const operation = 'outcomes'
  const defaultVariables = {
    universities: {
      value: [],
      required: true,
      list: true,
      name: 'universities',
    },
    useGeneralCatalog: { value: true, required: true },
    useNrmSchoolName: { value: true, required: true },
    cCurrentEmployers: { value: [], list: true, type: 'String' },
    cIndustries: { value: [], list: true, type: 'String' },
    cMajors: { value: [], list: true, type: 'String' },
    cSkills: { value: [], list: true, type: 'String' },
  }

  const { data, refetch, loading } = useQuery(operation, defaultVariables, {
    lazy: true,
  })

  return <BaseComponent {...props} outcomesData={data} getOutcomesData={refetch} loadingOutcomesData={loading} />
}

export default withOutcomes



// WEBPACK FOOTER //
// ./src/utils/graphql/hocs/withOutcomes.js